export const SAVED = "saved";
export const FAILED = "failed";
export const SENT = "SENT";
export const SUCCESS = "success";
